import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { UseContractSigningPageLogicreturnProps } from '../ContractSigningPageProps'
import { AppDispatch, AppState } from 'store'
import { HttpClient } from 'common/HttpClient'
import { Environment } from 'enviroment/AppSettings'
import { setCurrentFullSmsCode, setSendSmsCodeValidationError, SMS_CODE_STATUSES } from 'store/ContractSignSlice/ContractSignSlice'
import { AppLinks } from 'enviroment/AppLinks'
import { ConnectionState } from 'store/ApplicationSlice/middleware/credential-actions-models'
import applicationService from 'service/ApplicaionService/ApplicationService'
import { SMS_CODE_STATUSES_FROM_ALPHA } from 'service/ApplicaionService/ApplicationServiceModels'
import { isTrastiBroker } from 'common/helpers/helpers'

/**
 * Hooks obsługujący logikę głównego komponentu strony z podpisaniem umowy.
 */
const useContractSigningPageLogic = (): UseContractSigningPageLogicreturnProps   => {
   const dispatch = useDispatch<AppDispatch>()
   const navigate = useNavigate()

   const contractSignState = useSelector((state: AppState) => state.contractSignState)
   const successReturnUrl = useSelector((state: AppState) => state.applicationState.successReturnUrl)
   const [blockButton, setButtonBlock] = useState(false)

   // >>>>> HANDLERS
   const downloadAgreement = () => {
      setButtonBlock(true);
      const client = new HttpClient(Environment.apiUrl)
      client.download("files", true).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: "application/octet-stream"}))
        const a = document.createElement("a")
   
        a.href = url;
        a.download = contractSignState.agreemenFileName
        document.body.appendChild(a)
        a.click();
        setTimeout(function(){
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
        }, 100)
        
        setButtonBlock(false)
      })
   }

   const handleOnContractSigningSubmit = async () => {
      const verificationCode = Object.values(contractSignState.verificationCodeInputs).join("").trim()


      if(verificationCode.length < Object.keys(contractSignState.verificationCodeInputs).length){
         dispatch(setSendSmsCodeValidationError(SMS_CODE_STATUSES.VALIDATION_ERROR_FULL_CODE_REQUIRED))
      }
      else {
         try {
            const client = new HttpClient(Environment.apiUrl)
            const result = (await client.get<ConnectionState>("connection", true)).data
            
            if (!result.isFinished) {
               const signApplicationResponse = (await applicationService.signApplication({ smsCode: verificationCode }).then((p) => p))

               if(signApplicationResponse.isOk){
                  // Logika biznesowa - dla Trasti nie wyświetlamy naszego ekranu sukcesu, 
                  // tylko przekierowujemy użytkownika na link przekazany z HUBa
                  if(isTrastiBroker() && successReturnUrl.length > 0){
                     window.location.href = successReturnUrl
                  }
                  else {
                     navigate(AppLinks.success)
                  }
               }
               else {
                  switch(signApplicationResponse.code){ // Obsługa specyficznych kodów błędów z Backendu
                     case SMS_CODE_STATUSES_FROM_ALPHA.CLIENT_PESEL_RESERVED: { //Klient ma zastrzeżony numer PESEL
                        dispatch(setCurrentFullSmsCode(verificationCode))
                        
                        navigate(AppLinks.clientPeselReservedPage)
                        dispatch(setSendSmsCodeValidationError(SMS_CODE_STATUSES.VALIDATION_ERROR_CLIENT_PESEL_RESERVED))
                        break;
                     }
                     default: {
                        dispatch(setSendSmsCodeValidationError(SMS_CODE_STATUSES.VALIDATION_ERROR_WRONG_CODE))
                     }
                  }
               }
            }
         }
         catch (e) {
            dispatch(setSendSmsCodeValidationError(SMS_CODE_STATUSES.SEND_ERROR))
         }
      }
   }
  
   return {
      downloadAgreement,
      handleOnContractSigningSubmit,
      dispatch,

      contractSignState
   }
}

export default useContractSigningPageLogic